import React from "react";
import { Button } from "@repo/ui";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../hoc/withTranslations/withTranslations";

const LOCALE = "pages_NotFound";

const NotFound: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-center items-center h-screen text-center space-y-8">
      <h1 className="text-4xl font-bold">{t("notFoundTitle")}</h1>
      <p className="mt-4 text-lg">{t("notFoundMessage")}</p>
      <Button onClick={() => navigate("/")} label={t("backToHome")} />
    </div>
  );
};

export default withTranslations(LOCALE)(NotFound);
